var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDescarga(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3349 1.83496H43.6651C48.3595 1.83496 52.1651 5.64054 52.1651 10.335V43.6652C52.1651 48.3596 48.3595 52.1652 43.6651 52.1652H10.3349C5.64048 52.1652 1.8349 48.3596 1.8349 43.6652V10.335C1.8349 5.64054 5.64048 1.83496 10.3349 1.83496Z",
    fill: "url(#paint0_linear_511_2717)",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M36.1721 25.0244L37.2561 26.1084C37.7151 26.5674 37.7151 27.3096 37.2561 27.7637L27.7688 37.2559C27.3098 37.7148 26.5676 37.7148 26.1135 37.2559L16.6213 27.7637C16.1624 27.3047 16.1624 26.5625 16.6213 26.1084L17.7053 25.0244C18.1692 24.5605 18.926 24.5703 19.3801 25.0439L24.9856 30.9277L24.9856 16.8945C24.9856 16.2451 25.5081 15.7227 26.1575 15.7227L27.72 15.7227C28.3694 15.7227 28.8918 16.2451 28.8918 16.8945L28.8918 30.9277L34.4973 25.0439C34.9514 24.5654 35.7083 24.5557 36.1721 25.0244Z",
    fill: "#F9FCFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_511_2717",
    x1: 26.9474,
    y1: 3.91375,
    x2: 26.9474,
    y2: 47.4859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1971D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1754A2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDescarga);
export default __webpack_public_path__ + "static/media/icon-descarga.8fb1e9451e7dc5cd712f451294da796f.svg";
export { ForwardRef as ReactComponent };